import { defineQuery } from 'next-sanity'

export const careersApplicationProcessBlockFields = `
  _id,
  _type,
  heading,
  introText,
  decorativeShape,
  applicationStages[]{
    heading,
    mainText[]
  }
`

export const CAREERS_APPLICATION_PROCESS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-application-process-block"][0]{
    ${careersApplicationProcessBlockFields}
  }
`)
